import { useDispatch, useSelector } from "react-redux";
import { booksubmit } from "../redux/form/actions";
import frameImg from '../assets/img/icons/Frame.svg';
import vectorImg from '../assets/img/icons/Vector (1).svg';
function Form(){   
  const formData = useSelector((state)=> state);
  const dispatch = useDispatch();
    const onSubmitHandler = (e)=>{      
        e.preventDefault();
        const id = Math.random();
        const from = e.currentTarget.elements.from.value;
        const to = e.currentTarget.elements.to.value;
        const date = e.currentTarget.elements.date.value;
        const guests = e.currentTarget.elements.guests.value;
        const ticketclass = e.currentTarget.elements.ticketclass.value;
        dispatch(booksubmit(id,from, to, date, guests, ticketclass));
        e.target.reset();      
    }
    return(        
        <div className="mt-[160px] mx-4 md:mt-[160px] relative">
        <div className="bg-white rounded-md max-w-6xl w-full mx-auto">
        <form onSubmit={onSubmitHandler} className="first-hero lws-inputform">          
          <div className="des-from">
            <p>Destination From</p>
            <div className="flex flex-row">
              <img src={frameImg} alt="" />
              <select className="outline-none px-2 py-2 w-full" name="from" id="lws-from" required>
                <option value="" hidden>Please Select</option>
                <option>Dhaka</option>
                <option>Sylhet</option>
                <option>Saidpur</option>
                <option>Cox's Bazar</option>
              </select>
            </div>
          </div>          
          <div className="des-from">
            <p>Destination To</p>
            <div className="flex flex-row">
              <img src={frameImg} alt="" />
              <select className="outline-none px-2 py-2 w-full" name="to" id="lws-to" required>
                <option value="" hidden>Please Select</option>
                <option>Dhaka</option>
                <option>Sylhet</option>
                <option>Saidpur</option>
                <option>Cox's Bazar</option>
              </select>
            </div>
          </div>          
          <div className="des-from">
            <p>Journey Date</p>
            <input type="date" className="outline-none px-2 py-2 w-full date" name="date" id="lws-date" required />
          </div>          
          <div className="des-from">
            <p>Guests</p>
            <div className="flex flex-row">
              <img src={vectorImg} alt="" />
              <select className="outline-none px-2 py-2 w-full" name="guests" id="lws-guests" required>
                <option value="" hidden>Please Select</option>
                <option value="1">1 Person</option>
                <option value="2">2 Persons</option>
                <option value="3">3 Persons</option>
                <option value="4">4 Persons</option>
              </select>
            </div>
          </div>         
          <div className="des-from !border-r-0">
            <p>Class</p>
            <div className="flex flex-row">
              <img src={vectorImg} alt="" />
              <select className="outline-none px-2 py-2 w-full" name="ticketclass" id="lws-ticketclass" required>
                <option value="" hidden>Please Select</option>
                <option>Business</option>
                <option>Economy</option>
              </select>
            </div>
          </div>
          <button className="addCity" type="submit" id="lws-addCity" style={formData.ticket.length >= 3 ? {cursor:"not-allowed"} : {cursor: "pointer"}} disabled={formData.ticket.length >= 3}>
            <svg width="15px" height="15px" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            <span className="text-sm">Book</span>
          </button>
        </form>                
        </div>
        </div>       
    );
}

export default Form;